import { render, staticRenderFns } from "./headerTap.vue?vue&type=template&id=65398ed1&scoped=true"
import script from "./headerTap.vue?vue&type=script&lang=js"
export * from "./headerTap.vue?vue&type=script&lang=js"
import style0 from "./headerTap.vue?vue&type=style&index=0&id=65398ed1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65398ed1",
  null
  
)

export default component.exports